import React from "react";

import { Form, Table } from "react-bootstrap";

import { useCoachReviewContext } from "../contexts/CoachReview";
import { TeamRatings, TeamTypes } from "../types/coachreview";

import { capitalize } from "../../../../lib/utils";
import { ITeamRating } from "../../../../types/api";
import Stars from "./Stars";

interface Props {
    team: TeamTypes;
    ratedTeam: ITeamRating | undefined;
}

const Ratings = ({ team, ratedTeam }: Props): React.JSX.Element => {
    const coachRatingOptions: Record<keyof TeamRatings, string> = {
        headCoach: "Head Coach",
        asstCoach: "Assistant Coach(es)",
        spectators: "Spectators",
        overall: "Overall",
    };

    const { formMethods } = useCoachReviewContext();
    const { register } = formMethods;

    return (
        <div className="ratings">
            <div className="stars">
                <Table>
                    <tbody>
                        {(
                            Object.keys(coachRatingOptions) as Array<
                                keyof TeamRatings
                            >
                        ).map((ratingCategory, idx) => {
                            return (
                                <tr key={idx}>
                                    <td>
                                        {coachRatingOptions[ratingCategory]}
                                    </td>
                                    <td className="starContainer">
                                        <Form.Control
                                            type="hidden"
                                            {...register(
                                                `${team}.${ratingCategory}`,
                                            )}
                                        />
                                        <Stars
                                            team={team}
                                            ratedTeam={ratedTeam}
                                            ratingCategory={ratingCategory}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default Ratings;
